import React from 'react';
import PropTypes from 'prop-types';
import Close from '../../../assets/svg/close';
import { colors } from 'kangarootime-ui';
import './GalleryPhoto.css';
import NetworkPhoto from '../../../components/NetworkPhoto';
import useHover from '../../../hooks/useHover';

const GalleryPhoto = ({ source, groupImageId, handlePhotoDeleteRequest }) => {
  const [ isHovered, bind ] = useHover();

  const handleClick = event => {
    event.preventDefault();
    event.stopPropagation();

    handlePhotoDeleteRequest(groupImageId);
  };

  return (
    <div
      {...bind}
      className='flex-1 flex-columns'
      style={{ cursor: 'pointer' }}
    >
      { isHovered
        ? <div className='removalContainer' onClick={handleClick}>
          <Close fill={colors.danger} />
        </div>
        : null
      }
      <NetworkPhoto
        source={source}
        height={160}
      />
    </div>
  );
};

GalleryPhoto.propTypes = {
  source: PropTypes.string,
  groupImageId: PropTypes.number,
  handlePhotoDeleteRequest: PropTypes.func
};

export default GalleryPhoto;
